import { update } from "lodash";

/*
 * @Author: Huangxianlong
 * @Date: 2023-08-14 11:43:48
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-04-29 09:59:49
 * @FilePath: \monitor\src\language\data\realtime.js
 * @Description: 
 */
const info = {
  CN: {
    sensorList: "传感器列表",
    treeType: "树状型",
    selectType: "选择型",
    queryBtn: "查询",
    resetBtn: "重置",
    timePla: "请选择起止时间",
    gcraphicOptions: "图形选项",
    linetype: "线型",
    displayAlerts: "显示警报值",
    lineWidth: "线宽",
    dotSize: "点大小",
    showTooltip: "显示tooltip",
    showLegend: "显示图例",
    solidLine: "实线",
    dottedLine: "虚线",
    yes: "是",
    no: "否",
    normal: "正常",
    fine: "细",
    coarse: "粗",
    small: "小",
    big: "大",
    editBtn: "修改",
    cancelBtn: "取消",
    exportPDF: "导出PDF",
    exportEXCEL: "导出EXCEL",
    exportCSV: "导出CSV",
    print: "打印",
    lastDay: "近一天",
    lastWeek: "近一周",
    lastMonth: "近一个月",
    threeMonth: "近三个月",
    goBack: "返回上一层",
    realtime: "实时视频",
    realtimeBtn: "实时数据",
    playback: "视频回放",
    merge: "合并",
    split: "拆分",
    dataSheet: "数据表",
    show: "显示",
    hide: "隐藏",
    time: "时间",
    value: "数值",
    videoMsg: "该传感器未绑定监控设备或监控设备不存在",
    errVMPrism: "VM、AC、IPI001和TotalStation类型传感器不能和其它传感器混合选择且不能选择多个VM、AC类型传感器，只能选择一个VM、AC类型传感器",
    tips: "温馨提示",
    frequency: "刷新周期(秒)",
    refresh: "刷新",
    queryFailed: "查询失败",
    timeFrame: "显示周期数",
    currentFrequency: "当前采集周期为",
    realtimeNoData: "选择的时间范围内无触发记录",
    readingRecords: "区间最大值记录表",
    triggerRecords: "振动触发记录表",
    timeSchedule: "时程图",
    positionSortingDiagram: "位置排序图",
    displacementMap: "位移图",
    groupSelect: "分组选择",
    groupSelectRule: "分组不能为空",
    date: "日期",
    datePla: "请选择日期",
    dateRule: "日期不能为空",
    pointOfTime: "时间点",
    pointOfTimeRule: "时间点不能为空",
    downLoad: "下载",
    returnData: "回传数据文件到服务器",
    returnSuccess: "数据文件已回传到服务器",
    returnInProgress: "数据文件回传中",
    updateSuccess: "更新文件状态成功",
    sensorName: "传感器名称",
    temperature: "温度(℃)",
    voltage: "电压(V)",
    filePath: "文件路径",
    fileStatus: "文件状态",
    downloadCSV: "CSV下载",
    acX: "加速度-X方向(mg)",
    acY: "加速度-Y方向(mg)",
    acZ: "加速度-Z方向(mg)",
    trigger: "触发方向",
    waveform: "振动波形图",
    eventId: "事件编号",
    eventTime: "触发时间",
    SensorId: "传感器编号",
    groupDataTable: "分组数据表",
    drawingTypes: "图型类型",
    lineChartSwitching: "图型切换",
    brokenLine: "折线",
    histogram: "直方",
    speedCsv: "速度CSV",
    accelerationCsv: "加速度CSV",
    directionSelect: "方向",
    depthUnit: "深度(m)",
    depth: "深度",
    displacement: "累计位移",
    displacementUnit: "位移",
    variationUnit: "单次变化",
    curveType: "曲线类型",
    cumulative: "累计位移",
    variation: "单次变化",
    comprehensive: "累计位移 + 单次变化",
    cumulativeName: "累计",
    variationName: "变化量",
    tableControl: "表格显示",
    inclinometer: "测斜仪",
    client: "客户",
    project: "项目",
    location: "位置",
    installationDepth: "安装深度 (m)",
    alertLevel: "告警值",
    wsl: "危险值",
    pipeTop: "管顶部高程 (m)",
    groundLevel: "地面高程 (m)",
    initialReading: "初值时间",
    lastReading: "最后数据时间",
    vibrationData: "速度峰值(mm/s)",
    frequencyData: "频率(Hz)",
    dataType: "数据类型",
    normalData: "正常数据",
    testData: "测试数据",
    abnormalData: "异常数据",
    remark: "标注",
    remarkPla: "请输入标注",
    remarkRules: "标注不能为空",
    situation: "情况说明",
    picture: "图片",
    deleteImageTips: "删除操作不可恢复，是否继续删除该图片？",
    formatWarning: "上传图片只能是 jpg、jpeg、png 格式!",
    sizeWarning: "上传的图片不能超过 2MB!",
    existsWarning: "该图片已存在，请选择其他图片！",
  },
  EN: {
    sensorList: "Sensor List",
    treeType: "Tree",
    selectType: "Select",
    queryBtn: "Query",
    resetBtn: "Reset",
    timePla: "Please select the start and end time",
    gcraphicOptions: "Graphic Options",
    linetype: "Linetype",
    displayAlerts: "Display alerts",
    lineWidth: "Line Width",
    dotSize: "Dot Size",
    showTooltip: "Show Tooltip",
    showLegend: "Show Legend",
    solidLine: "Solid Line",
    dottedLine: "Dotted Line",
    yes: "Yes",
    no: "No",
    normal: "Normal",
    fine: "Fine",
    coarse: "Coarse",
    small: "Small",
    big: "Big",
    editBtn: "Edit",
    cancelBtn: "Cancel",
    exportPDF: "Export PDF",
    exportEXCEL: "Export EXCEL",
    exportCSV: "Export CSV",
    print: "Print",
    lastDay: "A Day",
    lastWeek: "A Week",
    lastMonth: "A Month",
    threeMonth: "Three Month",
    goBack: "Go Back",
    realtime: "Video Realtime",
    realtimeBtn: "Real time",
    playback: "Video Playback",
    merge: "merge",
    split: "split",
    dataSheet: "Data Sheet",
    show: "show",
    hide: "hide",
    time: "Time",
    value: "Value",
    videoMsg: "The sensor is not bound to a monitoring device or the monitoring device does not exist",
    errVMPrism: "Sensors of types VM, AC, IPI001, and TotalStation cannot be mixed with other sensor types, and multiple VM or AC type sensors cannot be selected. Only one VM or AC type sensor can be chosen",
    tips: "Tips",
    frequency: "Refresh Frequency (seconds)",
    refresh: "Refresh",
    queryFailed: "Query failed",
    timeFrame: "Display number of cycles",
    currentFrequency: "The current collection cycle is ",
    realtimeNoData: "No trigger record in the selected period",
    readingRecords: "Period Maximum Reading Records",
    triggerRecords: "Vibration Trigger Records",
    timeSchedule: "Time schedule diagram",
    positionSortingDiagram: "Position sorting diagram",
    displacementMap: "Displacement map",
    cumulative: "Displacement map",
    groupSelect: "Group",
    pointOfTime: "Cycle Time",
    groupSelectRule: "Grouping cannot be empty",
    date: "Date",
    datePla: "Please select a date",
    dateRule: "Date cannot be empty",
    pointOfTimeRule: "Cycle time cannot be empty",
    downLoad: "DownLoad",
    returnData: "Return data files to the server",
    returnSuccess: "Data file successfully returned",
    returnInProgress: "Returning in progress",
    updateSuccess: "Successfully updated file status",
    sensorName: "Sensor Name",
    temperature: "Temperature (℃)",
    voltage: "Voltage (V)",
    filePath: "File Path",
    fileStatus: "File Status",
    downloadCSV: "CSV Download",
    acX: "ac_x (mg)",
    acY: "ac_y (mg)",
    acZ: "ac_z (mg)",
    trigger: "Trigger",
    waveform: "Vibration waveform diagram",
    eventId: "Event Id",
    eventTime: "Event Time",
    SensorId: "Sensor Id",
    groupDataTable: "Grouping Data Table",
    drawingTypes: "Drawing Types",
    lineChartSwitching: "Pattern switching",
    brokenLine: "line",
    histogram: "histogram",
    accelerationCsv: "Acceleration CSV",
    speedCsv: "Speed CSV",
    directionSelect: "Direction",
    depthUnit: "depth(m)",
    depth: "depth",
    displacement: "Cumulative displacement",
    curveType: "Curve type",
    cumulative: "Cumulative displacement",
    variation: "Variation",
    comprehensive: "Cumulative displacement + Variation",
    cumulativeName: "cumulative",
    variationName: "variation",
    variationUnit: "variation",
    displacementUnit: "displacement",
    tableControl: "Table display",
    inclinometer: "Inclinometer",
    client: "Client",
    project: "Project",
    location: "Location",
    installationDepth: "Installation Depth (m)",
    alertLevel: "Alert Level",
    wsl: "Suspension Level",
    pipeTop: "Pipe Top (m)",
    groundLevel: "Ground Level (m)",
    initialReading: "Date of Initial Reading",
    lastReading: "Date of Last Reading",
    vibrationData: "Speed peak(mm/s)",
    frequencyData: "Frequency(Hz)",
    dataType: "Data type",
    testData: "Test data",
    normalData: "Normal data",
    abnormalData: "Abnormal data",
    remark: "Label",
    remarkPla: "Please enter remarks",
    remarkRules: "Remark cannot be empty",
    situation: "Explanation of the Situation",
    picture: "picture",
    deleteImageTips: "The deletion operation is irreversible. Do you still want to delete this image?",
    formatWarning: "Uploading images can only be in JPG, JPEG, PNG formats!",
    sizeWarning: "The uploaded image cannot exceed 2MB!",
    existsWarning: "The image already exists, please choose another image!",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/data/realtime.js